import React from 'react';
import logo from './logo.svg';
import './App.css';
import { SafeArea, TabBar } from 'antd-mobile';
import {

  MoreOutline,
} from 'antd-mobile-icons'
import { Basketball, Football, Hot } from './svgs';
import useSWR from 'swr';
import { CategoryTabs } from './Category';
import { Result } from './types';

const DataUrl = "https://static-1yang.oss-cn-hangzhou.aliyuncs.com/games/yoozhibo.json";
const fetcher = (url: string) => fetch(url).then((res) => res.json());
const tabs = [
  {
    key: '0',
    title: '热门',
    // eslint-disable-next-line react/jsx-no-undef
    icon: <Hot />,
  },
  {
    key: '2',
    title: '篮球',
    icon: <Basketball />,
    badge: '5',
  },
  {
    key: '1',
    title: '足球',
    icon: <Football />,
  },
  {
    key: '3',
    title: '其他',
    icon: <MoreOutline />,
  },
]
function App() {

  const [activeKey, setActiveKey,] = React.useState('0');
  const { data, error, isLoading } = useSWR(DataUrl, fetcher, { refreshInterval: 1000 * 60 });
  const gameInfo = data as Result;
  if (error) console.log("error", error)
  if (isLoading) console.log("isLoading", isLoading)
  // console.log("data", data)
  return (
    <div className='app-container'>
      <div style={{ background: '#ace0ff' }}>
        <SafeArea position='top' />
      </div>
      <TabBar safeArea onChange={setActiveKey} activeKey={activeKey} style={{ borderBottom: "1px solid #1677ff" }}>
        {tabs.map(item => (
          <TabBar.Item key={item.key} icon={item.icon} title={item.title} />
        ))}
      </TabBar>
      <div className='content-container'>
        <div style={{ backgroundColor: "white", minHeight: '60vh', display: activeKey === "0" ? "block" : "none" }}>
          <CategoryTabs c="0" games={gameInfo?.games || []} domain={gameInfo?.website} />
        </div>
        <div style={{ backgroundColor: "white", minHeight: '60vh', display: activeKey === "2" ? "block" : "none" }}>
          <CategoryTabs c="2" games={gameInfo?.games || []} domain={gameInfo?.website} />
        </div>
        <div style={{ backgroundColor: "white", minHeight: '60vh', display: activeKey === "1" ? "block" : "none" }}>
          <CategoryTabs c="1" games={gameInfo?.games || []} domain={gameInfo?.website} />
        </div>
        <div style={{ backgroundColor: "white", minHeight: '60vh', display: activeKey === "3" ? "block" : "none" }}>
          <CategoryTabs c="3" games={gameInfo?.games || []} domain={gameInfo?.website} />
        </div>
      </div>
      {/* <div style={{ position: 'sticky', backgroundColor: 'white', bottom: 0, borderTop: "1px solid #8080802b" }}>
        <TabBar safeArea onChange={setActiveKey} activeKey={activeKey} >
          {tabs.map(item => (
            <TabBar.Item key={item.key} icon={item.icon} title={item.title} />
          ))}
        </TabBar>
        <SafeArea position='bottom' />
        <div style={{ height: 20 }}></div>
      </div> */}
    </div>

  );
}

export default App;
